
import motion01 from './img/motion_01.png';
import motion02 from './img/motion_02.png';
import motion03 from './img/motion_03.png';
import motion04 from './img/motion_04.png';
import motion05 from './img/motion_05.png';
import motion06 from './img/motion_06.png';
import motion07 from './img/motion_07.png';
import motion08 from './img/motion_08.png';
import motion09 from './img/motion_09.png';
import motion10 from './img/motion_10.png';
import motion11 from './img/motion_11.png';
import motion12 from './img/motion_12.png';
import motion13 from './img/motion_13.png';
import motion14 from './img/motion_14.png';
import motion15 from './img/motion_15.png';
import motion16 from './img/motion_16.png';
import motion17 from './img/motion_17.png';
import motion18 from './img/motion_18.png';

import looks01 from './img/looks_01.png';
import looks02 from './img/looks_02.png';
import looks03 from './img/looks_03.png';
import looks04 from './img/looks_04.png';
import looks05 from './img/looks_05.png';
import looks06 from './img/looks_06.png';
import looks07 from './img/looks_07.png';
import looks08 from './img/looks_08.png';
import looks09 from './img/looks_09.png';
import looks10 from './img/looks_10.png';
import looks11 from './img/looks_11.png';
import looks12 from './img/looks_12.png';
import looks13 from './img/looks_13.png';
import looks14 from './img/looks_14.png';
import looks15 from './img/looks_15.png';
import looks16 from './img/looks_16.png';
import looks17 from './img/looks_17.png';
import looks18 from './img/looks_18.png';
import looks19 from './img/looks_19.png';
import looks20 from './img/looks_20.png';

import sound01 from './img/sound_01.png';
import sound02 from './img/sound_02.png';
import sound03 from './img/sound_03.png';
import sound04 from './img/sound_04.png';
import sound05 from './img/sound_05.png';
import sound06 from './img/sound_06.png';
import sound07 from './img/sound_07.png';
import sound08 from './img/sound_08.png';
import sound09 from './img/sound_09.png';

import events01 from './img/events_01.png';
import events02 from './img/events_02.png';
import events03 from './img/events_03.png';
import events04 from './img/events_04.png';
import events05 from './img/events_05.png';
import events06 from './img/events_06.png';
import events07 from './img/events_07.png';
import events08 from './img/events_08.png';

import control01 from './img/control_01.png';
import control02 from './img/control_02.png';
import control03 from './img/control_03.png';
import control04 from './img/control_04.png';
import control05 from './img/control_05.png';
import control06 from './img/control_06.png';
import control07 from './img/control_07.png';
import control08 from './img/control_08.png';
import control09 from './img/control_09.png';
import control10 from './img/control_10.png';
import control11 from './img/control_11.png';

import sensing01 from './img/sensing_01.png';
import sensing02 from './img/sensing_02.png';
import sensing03 from './img/sensing_03.png';
import sensing04 from './img/sensing_04.png';
import sensing05 from './img/sensing_05.png';
import sensing06 from './img/sensing_06.png';
import sensing07 from './img/sensing_07.png';
import sensing08 from './img/sensing_08.png';
import sensing09 from './img/sensing_09.png';
import sensing10 from './img/sensing_10.png';
import sensing11 from './img/sensing_11.png';
import sensing12 from './img/sensing_12.png';
import sensing13 from './img/sensing_13.png';
import sensing14 from './img/sensing_14.png';
import sensing15 from './img/sensing_15.png';
import sensing16 from './img/sensing_16.png';
import sensing17 from './img/sensing_17.png';
import sensing18 from './img/sensing_18.png';

import operators01 from './img/operators_01.png';
import operators02 from './img/operators_02.png';
import operators03 from './img/operators_03.png';
import operators04 from './img/operators_04.png';
import operators05 from './img/operators_05.png';
import operators06 from './img/operators_06.png';
import operators07 from './img/operators_07.png';
import operators08 from './img/operators_08.png';
import operators09 from './img/operators_09.png';
import operators10 from './img/operators_10.png';
import operators11 from './img/operators_11.png';
import operators12 from './img/operators_12.png';
import operators13 from './img/operators_13.png';
import operators14 from './img/operators_14.png';
import operators15 from './img/operators_15.png';
import operators16 from './img/operators_16.png';
import operators17 from './img/operators_17.png';
import operators18 from './img/operators_18.png';

import variables01 from './img/variables_01.png';

import myBlocks01 from './img/myBlocks_01.png';

const virtualBlockInfo = {
    motion: [
        {
            category: 'motion',
            id: 'motion_01',
            img: `${motion01}`,
            opcode: "motion_movesteps",
            value: `<block type="motion_movesteps">
                <value name="STEPS">
                    <shadow type="math_number">
                        <field name="NUM">10</field>
                    </shadow>
                </value>
            </block>`
        },
        {
            category: 'motion',
            id: 'motion_02',
            img: `${motion02}`,
            opcode: "motion_turnright",
            value: `<block type="motion_turnright">
                <value name="DEGREES">
                    <shadow type="math_number">
                        <field name="NUM">15</field>
                    </shadow>
                </value>
            </block>`
        },
        {
            category: 'motion',
            id: 'motion_03',
            img: `${motion03}`,
            opcode: "motion_turnleft",
            value: '<block type="motion_turnleft"><value name="DEGREES"><shadow type="math_number"><field name="NUM">15</field></shadow></value></block>${blockSeparator}'
        },
        {
            category: 'motion',
            id: 'motion_04',
            img: `${motion04}`,
            opcode: "motion_goto",
            value: `<block type="motion_goto">
                <value name="TO">
                    <shadow type="motion_goto_menu">
                    </shadow>
                </value>
            </block>`
        },
        {
            category: 'motion',
            id: 'motion_05',
            img: `${motion05}`,
            opcode: "motion_gotoxy",
            value: `<block type="motion_gotoxy">
                <value name="X">
                    <shadow id="movex" type="math_number">
                        <field name="NUM">0</field>
                    </shadow>
                </value>
                <value name="Y">
                    <shadow id="movey" type="math_number">
                        <field name="NUM">0</field>
                    </shadow>
                </value>
            </block>`
        },
        {
            category: 'motion',
            id: 'motion_06',
            img: `${motion06}`,
            opcode: "motion_glideto",
            value: `<block type="motion_glideto" id="motion_glideto">
                <value name="SECS">
                    <shadow type="math_number">
                        <field name="NUM">1</field>
                    </shadow>
                </value>
                <value name="TO">
                    <shadow type="motion_glideto_menu">
                    </shadow>
                </value>
            </block>`
        },
        {
            category: 'motion',
            id: 'motion_07',
            img: `${motion07}`,
            opcode: "motion_glidesecstoxy",
            value: '<block type="motion_glidesecstoxy"><value name="SECS"><shadow type="math_number"><field name="NUM">1</field></shadow></value><value name="X"><shadow id="glidex" type="math_number"><field name="NUM">0</field></shadow></value><value name="Y"><shadow id="glidey" type="math_number"><field name="NUM">0</field></shadow></value></block>${blockSeparator}'
        },
        {
            category: 'motion',
            id: 'motion_08',
            img: `${motion08}`,
            opcode: "motion_pointindirection",
            value: `<block type="motion_pointindirection">
                <value name="DIRECTION">
                    <shadow type="math_angle">
                        <field name="NUM">90</field>
                    </shadow>
                </value>
            </block>`
        },
        {
            category: 'motion',
            id: 'motion_09',
            img: `${motion09}`,
            opcode: "motion_pointtowards",
            value: '<block type="motion_pointtowards"><value name="TOWARDS"><shadow type="motion_pointtowards_menu"></shadow></value></block>${blockSeparator}'
        },
        {
            category: 'motion',
            id: 'motion_10',
            img: `${motion10}`,
            opcode: "motion_changexby",
            value: `<block type="motion_changexby">
                <value name="DX">
                    <shadow type="math_number">
                        <field name="NUM">10</field>
                    </shadow>
                </value>
            </block>`
        },
        {
            category: 'motion',
            id: 'motion_11',
            img: `${motion11}`,
            opcode: "motion_setx",
            value: `<block type="motion_setx">
                <value name="X">
                    <shadow id="setx" type="math_number">
                        <field name="NUM">0</field>
                    </shadow>
                </value>
            </block>`
        },
        {
            category: 'motion',
            id: 'motion_12',
            img: `${motion12}`,
            opcode: "motion_changeyby",
            value: `<block type="motion_changeyby">
                <value name="DY">
                    <shadow type="math_number">
                        <field name="NUM">10</field>
                    </shadow>
                </value>
            </block>`
        },
        {
            category: 'motion',
            id: 'motion_13',
            img: `${motion13}`,
            opcode: "motion_sety",
            value: '<block type="motion_sety"><value name="Y"><shadow id="sety" type="math_number"><field name="NUM">0</field></shadow></value></block>${blockSeparator}'
        },
        {
            category: 'motion',
            id: 'motion_14',
            img: `${motion14}`,
            opcode: "motion_ifonedgebounce",
            value: '<block type="motion_ifonedgebounce"/>${blockSeparator}'
        },
        {
            category: 'motion',
            id: 'motion_15',
            img: `${motion15}`,
            opcode: "motion_setrotationstyle",
            value: '<block type="motion_setrotationstyle"/>${blockSeparator}'
        },
        {
            category: 'motion',
            id: 'motion_16',
            img: `${motion16}`,
            opcode: "motion_xposition",
            value: '<block id="${targetId}_xposition" type="motion_xposition"/>'
        },
        {
            category: 'motion',
            id: 'motion_17',
            img: `${motion17}`,
            opcode: "motion_yposition",
            value: '<block id="${targetId}_yposition" type="motion_yposition"/>'
        },
        {
            category: 'motion',
            id: 'motion_18',
            img: `${motion18}`,
            opcode: "motion_direction",
            value: '<block id="${targetId}_direction" type="motion_direction"/>'
        }
    ],
    looks: [
        {
            category: 'looks',
            id: 'looks_01',
            img: `${looks01}`,
            opcode: "looks_sayforsecs",
            value: '<block type="looks_sayforsecs"><value name="MESSAGE"><shadow type="text"><field name="TEXT">${hello}</field></shadow></value><value name="SECS"><shadow type="math_number"><field name="NUM">2</field></shadow></value></block>'
        },
        {
            category: 'looks',
            id: 'looks_02',
            img: `${looks02}`,
            opcode: "looks_say",
            value: '<block type="looks_say"><value name="MESSAGE"><shadow type="text"><field name="TEXT">${hello}</field></shadow></value></block>'
        },
        {
            category: 'looks',
            id: 'looks_03',
            img: `${looks03}`,
            opcode: "looks_thinkforsecs",
            value: '<block type="looks_thinkforsecs"><value name="MESSAGE"><shadow type="text"><field name="TEXT">${hmm}</field></shadow></value><value name="SECS"><shadow type="math_number"><field name="NUM">2</field></shadow></value></block>'
        },
        {
            category: 'looks',
            id: 'looks_04',
            img: `${looks04}`,
            opcode: "looks_think",
            value: '<block type="looks_think"><value name="MESSAGE"><shadow type="text"><field name="TEXT">${hmm}</field></shadow></value></block>${blockSeparator}'
        },
        {
            category: 'looks',
            id: 'looks_05',
            img: `${looks05}`,
            opcode: "looks_switchcostumeto",
            value: '<block id="${targetId}_switchcostumeto" type="looks_switchcostumeto"><value name="COSTUME"><shadow type="looks_costume"/></value></block>'
        },
        {
            category: 'looks',
            id: 'looks_06',
            img: `${looks06}`,
            opcode: "looks_nextcostume",
            value: `<block type="looks_nextcostume"/>`
        },
        {
            category: 'looks',
            id: 'looks_07',
            img: `${looks07}`,
            opcode: "looks_switchbackdropto",
            value: `<block type="looks_switchbackdropto">
                <value name="BACKDROP">
                    <shadow type="looks_backdrops"/>
                </value>
            </block>`
        },
        {
            category: 'looks',
            id: 'looks_08',
            img: `${looks08}`,
            opcode: "looks_nextbackdrop",
            value: '<block type="looks_nextbackdrop"/>${blockSeparator}'
        },
        {
            category: 'looks',
            id: 'looks_09',
            img: `${looks09}`,
            opcode: "looks_changesizeby",
            value: `<block type="looks_changesizeby">
                <value name="CHANGE">
                    <shadow type="math_number">
                        <field name="NUM">10</field>
                    </shadow>
                </value>
            </block>`
        },
        {
            category: 'looks',
            id: 'looks_10',
            img: `${looks10}`,
            opcode: "looks_setsizeto",
            value: `<block type="looks_setsizeto">
                <value name="SIZE">
                    <shadow type="math_number">
                        <field name="NUM">100</field>
                    </shadow>
                </value>
            </block>`
        },
        {
            category: 'looks',
            id: 'looks_11',
            img: `${looks11}`,
            opcode: "looks_changeeffectby",
            value: '${blockSeparator}<block type="looks_changeeffectby"><value name="CHANGE"><shadow type="math_number"><field name="NUM">25</field></shadow></value></block>'
        },
        {
            category: 'looks',
            id: 'looks_12',
            img: `${looks12}`,
            opcode: "looks_seteffectto",
            value: `<block type="looks_seteffectto">
                <value name="VALUE">
                    <shadow type="math_number">
                        <field name="NUM">0</field>
                    </shadow>
                </value>
            </block>`
        },
        {
            category: 'looks',
            id: 'looks_13',
            img: `${looks13}`,
            opcode: "looks_cleargraphiceffects",
            value: '<block type="looks_cleargraphiceffects"/>${blockSeparator}'
        },
        {
            category: 'looks',
            id: 'looks_14',
            img: `${looks14}`,
            opcode: "looks_show",
            value: `<block type="looks_show"/>`
        },
        {
            category: 'looks',
            id: 'looks_15',
            img: `${looks15}`,
            opcode: "looks_hide",
            value: '<block type="looks_hide"/>${blockSeparator}'
        },
        {
            category: 'looks',
            id: 'looks_16',
            img: `${looks16}`,
            opcode: "looks_gotofrontback",
            value: `<block type="looks_gotofrontback"/>`
        },
        {
            category: 'looks',
            id: 'looks_17',
            img: `${looks17}`,
            opcode: "looks_goforwardbackwardlayers",
            value: `<block type="looks_goforwardbackwardlayers">
                <value name="NUM">
                    <shadow type="math_integer">
                        <field name="NUM">1</field>
                    </shadow>
                </value>
            </block>`
        },
        {
            category: 'looks',
            id: 'looks_18',
            img: `${looks18}`,
            opcode: "looks_costumenumbername",
            value: '<block id="${targetId}_costumenumbername" type="looks_costumenumbername"/>'
        },
        {
            category: 'looks',
            id: 'looks_19',
            img: `${looks19}`,
            opcode: "looks_backdropnumbername",
            value: `<block id="backdropnumbername" type="looks_backdropnumbername"/>`
        },
        {
            category: 'looks',
            id: 'looks_20',
            img: `${looks20}`,
            opcode: "looks_size",
            value: '<block id="${targetId}_size" type="looks_size"/>'
        }
    ],
    sound: [
        {
            category: 'sound',
            id: 'sound_01',
            img: `${sound01}`,
            opcode: "sound_playuntildone",
            value: '<block id="${targetId}_sound_playuntildone" type="sound_playuntildone"><value name="SOUND_MENU"><shadow type="sound_sounds_menu"/></value></block>'
        },
        {
            category: 'sound',
            id: 'sound_02',
            img: `${sound02}`,
            opcode: "sound_play",
            value: '<block id="${targetId}_sound_play" type="sound_play"><value name="SOUND_MENU"><shadow type="sound_sounds_menu"/></value></block>'
        },
        {
            category: 'sound',
            id: 'sound_03',
            img: `${sound03}`,
            opcode: "sound_stopallsounds",
            value: '<block type="sound_stopallsounds"/>${blockSeparator}'
        },
        {
            category: 'sound',
            id: 'sound_04',
            img: `${sound04}`,
            opcode: "sound_changeeffectby",
            value: `<block type="sound_changeeffectby">
                <value name="VALUE">
                    <shadow type="math_number">
                        <field name="NUM">10</field>
                    </shadow>
                </value>
            </block>`
        },
        {
            category: 'sound',
            id: 'sound_05',
            img: `${sound05}`,
            opcode: "sound_seteffectto",
            value: `<block type="sound_seteffectto">
                <value name="VALUE">
                    <shadow type="math_number">
                        <field name="NUM">100</field>
                    </shadow>
                </value>
            </block>`
        },
        {
            category: 'sound',
            id: 'sound_06',
            img: `${sound06}`,
            opcode: "sound_cleareffects",
            value: '<block type="sound_cleareffects"/>${blockSeparator}'
        },
        {
            category: 'sound',
            id: 'sound_07',
            img: `${sound07}`,
            opcode: "sound_changevolumeby",
            value: `<block type="sound_changevolumeby">
                <value name="VOLUME">
                    <shadow type="math_number">
                        <field name="NUM">-10</field>
                    </shadow>
                </value>
            </block>`
        },
        {
            category: 'sound',
            id: 'sound_08',
            img: `${sound08}`,
            opcode: "sound_setvolumeto",
            value: `<block type="sound_setvolumeto">
                <value name="VOLUME">
                    <shadow type="math_number">
                        <field name="NUM">100</field>
                    </shadow>
                </value>
            </block>`
        },
        {
            category: 'sound',
            id: 'sound_09',
            img: `${sound09}`,
            opcode: "sound_volume",
            value: '<block id="${targetId}_volume" type="sound_volume"/>'
        }
    ],
    events: [
        {
            category: 'events',
            id: 'events_01',
            img: `${events01}`,
            opcode: "event_whenflagclicked",
            value: `<block type="event_whenflagclicked"/>`
        },
        {
            category: 'events',
            id: 'events_02',
            img: `${events02}`,
            opcode: "event_whenkeypressed",
            value: `<block type="event_whenkeypressed">
            </block>`
        },
        {
            category: 'events',
            id: 'events_03',
            img: `${events03}`,
            opcode: "event_whenthisspriteclicked",
            value: `<block type="event_whenthisspriteclicked"/>`
        },
        {
            category: 'events',
            id: 'events_04',
            img: `${events04}`,
            opcode: "event_whenbackdropswitchesto",
            value: '<block type="event_whenbackdropswitchesto"></block>${blockSeparator}'
        },
        {
            category: 'events',
            id: 'events_05',
            img: `${events05}`,
            opcode: "event_whengreaterthan",
            value: '<block type="event_whengreaterthan"><value name="VALUE"><shadow type="math_number"><field name="NUM">10</field></shadow></value></block>${blockSeparator}'
        },
        {
            category: 'events',
            id: 'events_06',
            img: `${events06}`,
            opcode: "event_whenbroadcastreceived",
            value: `<block type="event_whenbroadcastreceived">
            </block>`
        },
        {
            category: 'events',
            id: 'events_07',
            img: `${events07}`,
            opcode: "event_broadcast",
            value: `<block type="event_broadcast">
                <value name="BROADCAST_INPUT">
                    <shadow type="event_broadcast_menu"></shadow>
                </value>
            </block>`
        },
        {
            category: 'events',
            id: 'events_08',
            img: `${events08}`,
            opcode: "event_broadcastandwait",
            value: `<block type="event_broadcastandwait">
                <value name="BROADCAST_INPUT">
                  <shadow type="event_broadcast_menu"></shadow>
                </value>
            </block>`
        }
    ],
    control: [
        {
            category: 'control',
            id: 'control_01',
            img: `${control01}`,
            opcode: "control_wait",
            value: '<block type="control_wait"><value name="DURATION"><shadow type="math_positive_number"><field name="NUM">1</field></shadow></value></block>${blockSeparator}'
        },
        {
            category: 'control',
            id: 'control_02',
            img: `${control02}`,
            opcode: "control_repeat",
            value: `<block type="control_repeat">
                <value name="TIMES">
                    <shadow type="math_whole_number">
                        <field name="NUM">10</field>
                    </shadow>
                </value>
            </block>`
        },
        {
            category: 'control',
            id: 'control_03',
            img: `${control03}`,
            opcode: "control_forever",
            value: '<block id="forever" type="control_forever"/>${blockSeparator}'
        },
        {
            category: 'control',
            id: 'control_04',
            img: `${control04}`,
            opcode: "control_if",
            value: `<block type="control_if"/>`
        },
        {
            category: 'control',
            id: 'control_05',
            img: `${control05}`,
            opcode: "control_if_else",
            value: `<block type="control_if_else"/>`
        },
        {
            category: 'control',
            id: 'control_06',
            img: `${control06}`,
            opcode: "control_wait_until",
            value: `<block id="wait_until" type="control_wait_until"/>`
        },
        {
            category: 'control',
            id: 'control_07',
            img: `${control07}`,
            opcode: "control_repeat_until",
            value: '<block id="repeat_until" type="control_repeat_until"/>${blockSeparator}'
        },
        {
            category: 'control',
            id: 'control_08',
            img: `${control08}`,
            opcode: "control_stop",
            value: '<block type="control_stop"/>${blockSeparator}'
        },
        {
            category: 'control',
            id: 'control_09',
            img: `${control09}`,
            opcode: "control_start_as_clone",
            value: `<block type="control_start_as_clone"/>`
        },
        {
            category: 'control',
            id: 'control_10',
            img: `${control10}`,
            opcode: "control_create_clone_of",
            value: `<block type="control_create_clone_of">
                <value name="CLONE_OPTION">
                    <shadow type="control_create_clone_of_menu"/>
                </value>
            </block>`
        },
        {
            category: 'control',
            id: 'control_11',
            img: `${control11}`,
            opcode: "control_delete_this_clone",
            value: `<block type="control_delete_this_clone"/>`
        }
    ],
    sensing: [
        {
            category: 'sensing',
            id: 'sensing_01',
            img: `${sensing01}`,
            opcode: "sensing_touchingobject",
            value: `<block type="sensing_touchingobject">
                <value name="TOUCHINGOBJECTMENU">
                    <shadow type="sensing_touchingobjectmenu"/>
                </value>
            </block>`
        },
        {
            category: 'sensing',
            id: 'sensing_02',
            img: `${sensing02}`,
            opcode: "sensing_touchingcolor",
            value: `<block type="sensing_touchingcolor">
                <value name="COLOR">
                    <shadow type="colour_picker"/>
                </value>
            </block>`
        },
        {
            category: 'sensing',
            id: 'sensing_03',
            img: `${sensing03}`,
            opcode: "sensing_coloristouchingcolor",
            value: `<block type="sensing_coloristouchingcolor">
                <value name="COLOR">
                    <shadow type="colour_picker"/>
                </value>
                <value name="COLOR2">
                    <shadow type="colour_picker"/>
                </value>
            </block>`
        },
        {
            category: 'sensing',
            id: 'sensing_04',
            img: `${sensing04}`,
            opcode: "sensing_distanceto",
            value: '<block type="sensing_distanceto"><value name="DISTANCETOMENU"><shadow type="sensing_distancetomenu"/></value></block>${blockSeparator}'
        },
        {
            category: 'sensing',
            id: 'sensing_05',
            img: `${sensing05}`,
            opcode: "sensing_askandwait",
            value: '<block id="askandwait" type="sensing_askandwait"><value name="QUESTION"><shadow type="text"><field name="TEXT">${name}</field></shadow></value></block>'
        },
        {
            category: 'sensing',
            id: 'sensing_06',
            img: `${sensing06}`,
            opcode: "sensing_answer",
            value: '<block id="answer" type="sensing_answer"/>${blockSeparator}'
        },
        {
            category: 'sensing',
            id: 'sensing_07',
            img: `${sensing07}`,
            opcode: "sensing_keypressed",
            value: `<block type="sensing_keypressed">
                <value name="KEY_OPTION">
                    <shadow type="sensing_keyoptions"/>
                </value>
            </block>`
        },
        {
            category: 'sensing',
            id: 'sensing_08',
            img: `${sensing08}`,
            opcode: "sensing_mousedown",
            value: `<block type="sensing_mousedown"/>`
        },
        {
            category: 'sensing',
            id: 'sensing_09',
            img: `${sensing09}`,
            opcode: "sensing_mousex",
            value: `<block type="sensing_mousex"/>`
        },
        {
            category: 'sensing',
            id: 'sensing_10',
            img: `${sensing10}`,
            opcode: "sensing_mousey",
            value: `<block type="sensing_mousey"/>`
        },
        {
            category: 'sensing',
            id: 'sensing_11',
            img: `${sensing11}`,
            opcode: "sensing_setdragmode",
            value: '${blockSeparator}<block type="sensing_setdragmode" id="sensing_setdragmode"></block>${blockSeparator}'
        },
        {
            category: 'sensing',
            id: 'sensing_12',
            img: `${sensing12}`,
            opcode: "sensing_loudness",
            value: '${blockSeparator}<block id="loudness" type="sensing_loudness"/>${blockSeparator}'
        },
        {
            category: 'sensing',
            id: 'sensing_13',
            img: `${sensing13}`,
            opcode: "sensing_timer",
            value: `<block id="timer" type="sensing_timer"/>`
        },
        {
            category: 'sensing',
            id: 'sensing_14',
            img: `${sensing14}`,
            opcode: "sensing_resettimer",
            value: '<block type="sensing_resettimer"/>${blockSeparator}'
        },
        {
            category: 'sensing',
            id: 'sensing_15',
            img: `${sensing15}`,
            opcode: "sensing_of",
            value: '<block id="of" type="sensing_of"><value name="OBJECT"><shadow id="sensing_of_object_menu" type="sensing_of_object_menu"/></value></block>${blockSeparator}'
        },
        {
            category: 'sensing',
            id: 'sensing_16',
            img: `${sensing16}`,
            opcode: "sensing_current",
            value: `<block id="current" type="sensing_current"/>`
        },
        {
            category: 'sensing',
            id: 'sensing_17',
            img: `${sensing17}`,
            opcode: "sensing_dayssince2000",
            value: '<block type="sensing_dayssince2000"/>${blockSeparator}'
        },
        {
            category: 'sensing',
            id: 'sensing_18',
            img: `${sensing18}`,
            opcode: "sensing_username",
            value: `<block type="sensing_username"/>`
        }
    ],
    operators: [
        {
            category: 'operators',
            id: 'operators_01',
            img: `${operators01}`,
            opcode: "operator_add",
            value: `<block type="operator_add">
                <value name="NUM1">
                    <shadow type="math_number">
                        <field name="NUM"/>
                    </shadow>
                </value>
                <value name="NUM2">
                    <shadow type="math_number">
                        <field name="NUM"/>
                    </shadow>
                </value>
            </block>`
        },
        {
            category: 'operators',
            id: 'operators_02',
            img: `${operators02}`,
            opcode: "operator_subtract",
            value: `<block type="operator_subtract">
                <value name="NUM1">
                    <shadow type="math_number">
                        <field name="NUM"/>
                    </shadow>
                </value>
                <value name="NUM2">
                    <shadow type="math_number">
                        <field name="NUM"/>
                    </shadow>
                </value>
            </block>`
        },
        {
            category: 'operators',
            id: 'operators_03',
            img: `${operators03}`,
            opcode: "operator_multiply",
            value: `<block type="operator_multiply">
                <value name="NUM1">
                    <shadow type="math_number">
                        <field name="NUM"/>
                    </shadow>
                </value>
                <value name="NUM2">
                    <shadow type="math_number">
                        <field name="NUM"/>
                    </shadow>
                </value>
            </block>`
        },
        {
            category: 'operators',
            id: 'operators_04',
            img: `${operators04}`,
            opcode: "operator_divide",
            value: '<block type="operator_divide"><value name="NUM1"><shadow type="math_number"><field name="NUM"/></shadow></value><value name="NUM2"><shadow type="math_number"><field name="NUM"/></shadow></value></block>${blockSeparator}'
        },
        {
            category: 'operators',
            id: 'operators_05',
            img: `${operators05}`,
            opcode: "operator_random",
            value: '<block type="operator_random"><value name="FROM"><shadow type="math_number"><field name="NUM">1</field></shadow></value><value name="TO"><shadow type="math_number"><field name="NUM">10</field></shadow></value></block>${blockSeparator}'
        },
        {
            category: 'operators',
            id: 'operators_06',
            img: `${operators06}`,
            opcode: "operator_gt",
            value: `<block type="operator_gt">
                <value name="OPERAND1">
                    <shadow type="text">
                        <field name="TEXT"/>
                    </shadow>
                </value>
                <value name="OPERAND2">
                    <shadow type="text">
                        <field name="TEXT">50</field>
                    </shadow>
                </value>
            </block>`
        },
        {
            category: 'operators',
            id: 'operators_07',
            img: `${operators07}`,
            opcode: "operator_lt",
            value: `<block type="operator_lt">
                <value name="OPERAND1">
                    <shadow type="text">
                        <field name="TEXT"/>
                    </shadow>
                </value>
                <value name="OPERAND2">
                    <shadow type="text">
                        <field name="TEXT">50</field>
                    </shadow>
                </value>
            </block>`
        },
        {
            category: 'operators',
            id: 'operators_08',
            img: `${operators08}`,
            opcode: "operator_equals",
            value: '<block type="operator_equals"><value name="OPERAND1"><shadow type="text"><field name="TEXT"/></shadow></value><value name="OPERAND2"><shadow type="text"><field name="TEXT">50</field></shadow></value></block>${blockSeparator}'
        },
        {
            category: 'operators',
            id: 'operators_09',
            img: `${operators09}`,
            opcode: "operator_and",
            value: `<block type="operator_and"/>`
        },
        {
            category: 'operators',
            id: 'operators_10',
            img: `${operators10}`,
            opcode: "operator_or",
            value: `<block type="operator_or"/>`
        },
        {
            category: 'operators',
            id: 'operators_11',
            img: `${operators11}`,
            opcode: "operator_not",
            value: '<block type="operator_not"/>${blockSeparator}'
        },
        {
            category: 'operators',
            id: 'operators_12',
            img: `${operators12}`,
            opcode: "operator_join",
            value: '<block type="operator_join"><value name="STRING1"><shadow type="text"><field name="TEXT">${apple}</field></shadow></value><value name="STRING2"><shadow type="text"><field name="TEXT">${banana}</field></shadow></value></block>'
        },
        {
            category: 'operators',
            id: 'operators_13',
            img: `${operators13}`,
            opcode: "operator_letter_of",
            value: '<block type="operator_letter_of"><value name="LETTER"><shadow type="math_whole_number"><field name="NUM">1</field></shadow></value><value name="STRING"><shadow type="text"><field name="TEXT">${apple}</field></shadow></value></block>'
        },
        {
            category: 'operators',
            id: 'operators_14',
            img: `${operators14}`,
            opcode: "operator_length",
            value: '<block type="operator_length"><value name="STRING"><shadow type="text"><field name="TEXT">${apple}</field></shadow></value></block>'
        },
        {
            category: 'operators',
            id: 'operators_15',
            img: `${operators15}`,
            opcode: "operator_contains",
            value: '<block type="operator_contains" id="operator_contains"><value name="STRING1"><shadow type="text"><field name="TEXT">${apple}</field></shadow></value><value name="STRING2"><shadow type="text"><field name="TEXT">${letter}</field></shadow></value></block>${blockSeparator}'
        },
        {
            category: 'operators',
            id: 'operators_16',
            img: `${operators16}`,
            opcode: "operator_mod",
            value: `<block type="operator_mod">
                <value name="NUM1">
                    <shadow type="math_number">
                        <field name="NUM"/>
                    </shadow>
                </value>
                <value name="NUM2">
                    <shadow type="math_number">
                        <field name="NUM"/>
                    </shadow>
                </value>
            </block>`
        },
        {
            category: 'operators',
            id: 'operators_17',
            img: `${operators17}`,
            opcode: "operator_round",
            value: '<block type="operator_round"><value name="NUM"><shadow type="math_number"><field name="NUM"/></shadow></value></block>${blockSeparator}'
        },
        {
            category: 'operators',
            id: 'operators_18',
            img: `${operators18}`,
            opcode: "operator_mathop",
            value: `<block type="operator_mathop">
                <value name="NUM">
                    <shadow type="math_number">
                        <field name="NUM"/>
                    </shadow>
                </value>
            </block>`
        }
    ],
    variables: [{
        category: 'variables',
        id: 'variables_01',
        img: `${variables01}`,
        value: ''
    }],
    myBlocks: [{
        category: 'myBlocks',
        id: 'myBlocks_01',
        img: `${myBlocks01}`,
        value: ''
    }]
};

export const categoryObj = {
    motion: {
        name: '运动',
        xml: "function (isStage, targetId) {return `<category name='%{BKY_CATEGORY_MOTION}' id='motion' colour='#4C97FF' secondaryColour='#3373CC'>",
        xmlclose: '${categorySeparator}</category>`;}'
    },
    looks: {
        name: '外观',
        xml: "function (isStage, targetId) {return `<category name='%{BKY_CATEGORY_LOOKS}' id='looks' colour='#9966FF' secondaryColour='#774DCB'>",
        xmlclose: '${categorySeparator}</category>`;}'
    },
    sound: {
        name: '声音',
        xml: "function (isStage, targetId) {return `<category name='%{BKY_CATEGORY_SOUND}' id='sound' colour='#D65CD6' secondaryColour='#BD42BD'>",
        xmlclose: '${categorySeparator}</category>`;}'
    },
    events: {
        name: '事件',
        xml: "function () {return `<category name='%{BKY_CATEGORY_EVENTS}' id='events' colour='#E1BA3F' secondaryColour='#CC9900'>",
        xmlclose: '${categorySeparator}</category>`;}'
    },
    control: {
        name: '控制',
        xml: "function () {return `<category name='%{BKY_CATEGORY_CONTROL}' id='control' colour='#FFAB19' secondaryColour='#CF8B17'>",
        xmlclose: '${categorySeparator}</category>`;}'
    },
    sensing: {
        name: '侦测',
        xml: "function () {return `<category name='%{BKY_CATEGORY_SENSING}' id='sensing' colour='#4CBFE6' secondaryColour='#2E8EB8'>",
        xmlclose: '${categorySeparator}</category>`;}'
    },
    operators: {
        name: '运算',
        xml: "function () {return `<category name='%{BKY_CATEGORY_OPERATORS}' id='operators' colour='#40BF4A' secondaryColour='#389438'>",
        xmlclose: '${categorySeparator}</category>`;}'
    },
    variables: {
        name: '变量',
        xml: "function () {return `<category name='%{BKY_CATEGORY_VARIABLES}' id='variables' colour='#FF8C1A' secondaryColour='#DB6E00' custom='VARIABLE'>",
        xmlclose: '</category>`;}'
    },
    myBlocks: {
        name: '自定义',
        xml: "function () {return `<category name='%{BKY_CATEGORY_MYBLOCKS}' id='myBlocks' colour='#FF6680' secondaryColour='#FF4D6A' custom='PROCEDURE'>",
        xmlclose: '</category>`;}'
    },
    //下面的拓展是后加的，基本占只用到了id
    text2speech: {
        name: '文字朗读',
        xml: "function () {return `<category name='文字朗读' id='text2speech'> ",
        xmlclose: '</category>`;}'
    },
    speech2text: {
        name: '语音识别',
        xml: "function () {return `<category name='语音识别' id='speech2text'> ",
        xmlclose: '</category>`;}'
    },
    translate: {
        name: '翻译',
        xml: "function () {return `<category name='翻译' id='translate'> ",
        xmlclose: '</category>`;}'
    },
    doodleSense: {
        name: '涂鸦识别',
        xml: "function () {return `<category name='涂鸦识别' id='doodleSense'> ",
        xmlclose: '</category>`;}'
    },
    aichat: {
        name: '自然对话',
        xml: "function () {return `<category name='自然对话' id='aichat'> ",
        xmlclose: '</category>`;}'
    },
    txt2img: {
        name: '生成图片·',
        xml: "function () {return `<category name='生成图片' id='txt2img'> ",
        xmlclose: '</category>`;}'
    },
    ailab: {
        name: 'ai实验室·',
        xml: "function () {return `<category name='ai实验室' id='ailab'> ",
        xmlclose: '</category>`;}'
    }
};
export default virtualBlockInfo
